import $ from 'jquery';
import { Howl } from 'howler';

import plugin from './plugin';

class ProjectsPlayer {
	constructor(element) {
		this.$elements = $(element).find('.project-player');
		this.$playing = null

		$('.project-player-play').on('click', e => {
			const $this = $(e.currentTarget);
			const $newPlayer = $this.closest('.project-player');
			if (this.$playing === null || $newPlayer.data('id') != this.$playing.data('id')) {
				this.stop();
				this.load($newPlayer);
			} else {
				this.play();
			}
		});
		$('.project-player-pause').on('click', () => this.pause());
	}

	/**
	 * Play a song in the playlist.
	 * @param	{jQuery} $el JQuery element to play :)
	 */
	load($el) {
		this.$playing = $el;
		const src = $el.data('src');
		if (this.track) this.track.unload();

		const howlConfig = {
			src,
			html5: true, // Force to HTML5 so that the audio can stream in (best for large files).
			volume: 1,

			onend: this.stop,
		};
		this.track = new Howl(howlConfig);

		this.play();
	}

	pause() {
		if (this.track) this.track.pause();
		this.$playing.removeClass('is-playing');
	}


	play() {
		this.$playing.addClass('is-playing');
		if (this.track) this.track.play();
	}

	stop() {
		if (this.track) this.track.stop();
		if (this.$elements) this.$elements.removeClass('is-playing');
		this.$playing = null;
	}
}

plugin('ProjectsPlayer', ProjectsPlayer);

